// This file is automatically generated. Do not edit manually.

import { DeliveryPackageWithSourcesView } from "src/api/generated/erp/db/types/tables/deliveryPackageWithSourcesView";
import { Address } from "src/api/generated/erp/db/types/embeddables/address";
import { DeliveryPackageSourceType } from "src/api/generated/io/aavo/applications/db/erp/types/deliveryPackageSourceType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace DeliveryPackageBundleCreationApi {
	export async function getNonBundledDeliveryPackages(args: {
		deliveryPackageIds: Array<number>;
	}): Promise<Array<DeliveryPackageWithSourcesView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackagesBundleCreation/getNonBundledDeliveryPackages",
			method: "POST",
			data: {
				deliveryPackageIds: args.deliveryPackageIds,
			},
		});
		return response as Array<DeliveryPackageWithSourcesView>;
	}

	export async function getDeliveryPackageOptions(args: {
		searchQuery?: string;
		currentSelection: number | null | undefined;
		siteId: number;
		deliveryAddress: Address | null | undefined;
		sourceType: DeliveryPackageSourceType | null | undefined;
	}): Promise<Array<DeliveryPackageWithSourcesView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackagesBundleCreation/getDeliveryPackageOptions",
			method: "POST",
			data: {
				searchQuery: args.searchQuery,
				currentSelection: args.currentSelection,
				siteId: args.siteId,
				deliveryAddress: args.deliveryAddress,
				sourceType: args.sourceType,
			},
		});
		return response as Array<DeliveryPackageWithSourcesView>;
	}
}
